import React, { useRef } from "react";
import { IconSearch } from "@tabler/icons";
import cn from "classnames";
import { FilterProps } from "react-table";
import { DropdownHeader } from "../../Dropdown";

export type DefaultColumnFilterProps<T extends object> = FilterProps<T> & {
  children?: React.ReactNode;
};

export const DefaultColumnFilter = <T extends object>(
  props: DefaultColumnFilterProps<T>
): JSX.Element => {
  const { column, setFilter } = props;
  const filterInput = useRef<HTMLInputElement>(null);
  const filterIcon = useRef<HTMLSpanElement>(null);

  const onLoadFocus = () => {
    if (filterInput.current) filterInput.current.focus();
  };

  // include data onSubmit
  const onEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      setFilter(column.id, e.currentTarget.value);
      e.currentTarget.value = "";
      if (filterIcon.current) filterIcon.current.click();
    }
  };

  return (
    <>
      <span
        className="dropdown"
        data-bs-toggle="dropdown"
        ref={filterIcon}
        onClick={() => onLoadFocus()}
      >
        <IconSearch size="1rem" />
      </span>
      <div className={cn("dropdown-menu dropdown-menu-lg-end")}>
        <DropdownHeader>Filter Text</DropdownHeader>
        <span className="dropdown-item ms-auto">
          <input
            className="form-control"
            onKeyPress={onEnter}
            ref={filterInput}
          />
        </span>
      </div>
    </>
  );
};

export default DefaultColumnFilter;
